import React, {memo, useEffect, useState} from "react";
import moment from 'moment';
import {useHistory, useParams} from "react-router-dom";
import {connect} from 'react-redux';
import {Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@material-ui/core';
import theme from './style';
import {useConfig} from "../../context/configContext";
import translate from "../../misc/applyTranslation";
import toValue from "../../misc/serializeToValue";
import Pagination from "../../components/Pagination";
import {BorderSelect, SingleCheck} from "../../components/inputs";
import APICall from "../../misc/APICall";
import WarningSection from "../../components/WarningSection";
import Tabs from "../../components/Tabs";

const InvoiceDetails = props => {
  const config = useConfig();
  const classes = theme(config);
  const history = useHistory();
  const params = useParams();

  const {batch} = useParams();

  const {
    access_token,
  } = props;

  const [batches, setBatches] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchInvoices, setBatchInvoices] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  let selectedBatchImportedInvoiceNumber = null;

  if (selectedBatch) {
    selectedBatchImportedInvoiceNumber = batches.find(b => b.batch_id.toString() === selectedBatch.toString()).number_invoices_imported_to_pyramid;
  }

  const rowsPerPage = 10;

  const handleBatchChange = e => {
    setSelectedBatch(e);
    history.replace(`/${params.lang}/invoices/details/${e}`)
  }

  const fetchBatches = () => {
    APICall({
      access_token: access_token,
      url: `invoicing/batches?page=1&limit=100&status=invoiced`,
      verb: 'get',
    })
      .then(res => {
        setBatches(res.data);
      })
  }

  const fetchBatcheInvoices = (batch_id) => {
    let url = `invoices?limit=${rowsPerPage}&page=${page}&batch_id=${batch_id}`;

    if (selectedTab === 0) {
      url += `&pyramid_import_date=0`
    }

    APICall({
      access_token: access_token,
      url: url,
      verb: "get"
    })
      .then(res => {
        setBatchInvoices([...res.data]);
        setTotalPages(res.pages);
      })
  }

  const handlePagination = value => {
    setPage(value);
  }

  function formatNumberWithSpaces(number) {
    // Convert number to string
    let numStr = String(number);

    // Split the string into integer and decimal parts
    let [integerPart, decimalPart] = numStr.split(',');

    // Insert spaces every third non-decimal character in the integer part
    let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Combine integer and decimal parts with a comma
    return formattedIntegerPart + (decimalPart ? ',' + decimalPart : '');
  }

  useEffect(() => {
    fetchBatches();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (batches && batches.length > 0) {
      if (batch) {
        setSelectedBatch(batch);
        fetchBatcheInvoices(batch)
      } else {
        const firstBatch = batches[0].batch_id;
        setSelectedBatch(firstBatch);
        fetchBatcheInvoices(firstBatch);
      }
    }
    // eslint-disable-next-line
  }, [batch, batches, selectedBatch, page, selectedTab]);

  return (
    <React.Fragment>
      <Paper className={classes.paperPadding}>
        <Grid container className={classes.filterContainer}>
          <Grid item md={4}>
            {selectedBatch &&
              <BorderSelect
                onChange={e => handleBatchChange(e)}
                selected={selectedBatch}
                items={batches}
                invoiceDetailsSelect
              />
            }
          </Grid>
          <Grid item md={12} className={classes.tabsContainer}>
            <Tabs
              selected={selectedTab}
              onClick={e => setSelectedTab(e)}
              items={
                [
                  {
                    text: translate('invoices', 'invoice_latest_table_not_imported_filter'),
                    id: 0,
                  },
                  {
                    text: translate('invoices', 'invoice_latest_table_all_filter'),
                    id: 1
                  },
                ]
              }/>
          </Grid>
        </Grid>
      </Paper>
      <TableContainer component={Paper} className={classes.container}>
        {(selectedTab === 0 && Number(selectedBatchImportedInvoiceNumber) === 0) &&
          (<WarningSection>
            <span>{translate("invoices", "no_invoices_uploaded_text")}</span>
          </WarningSection>)
        }
        <div className='title'>{translate('invoices', 'invoices_details_page_title')}</div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{translate('invoices', 'invoice_latest_table_ocr')}</TableCell>
              <TableCell>{translate('invoices', 'invoice_latest_table_inv_cust_name')}</TableCell>
              <TableCell>{translate('invoices', 'invoice_latest_table_inv_day')}</TableCell>
              <TableCell>{translate('invoices', 'invoie_latest_table_inv_sum')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {batchInvoices.map((row) => (
              <TableRow key={row.id} className={!row.downloaded ? classes.bold : ''}>
                <TableCell>{row.ocr}</TableCell>
                <TableCell>{row.inv_cust_name}</TableCell>
                <TableCell>{moment.unix(row.inv_day).format('YYYY-MM-DD')}</TableCell>
                <TableCell>{formatNumberWithSpaces(toValue(row.inv_sum)) + " kr"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Pagination page={page} totalPages={totalPages} onClick={handlePagination}/>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = store => ({
  access_token: store.login.access_token,
  invoicedBatches: store.invoices.invoicedBatches.data,
});

export default connect(mapStateToProps)(memo(InvoiceDetails));
